import { ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { PageHeader } from '../components/layout/PageHeader';

export function AcercaDePage() {
  return (
    <div className="px-4 py-4" data-testid="acerca-page">
      <PageHeader 
        title="Acerca de" 
        subtitle="Información sobre Datacultivo"
        showBack
      />

      <div className="mt-4 space-y-4">
        {/* Logo */}
        <div className="text-center py-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_datacultivo/artifacts/pkxt3ok2_Logotipo%204.png" 
            alt="Datacultivo Logo" 
            className="h-24 w-auto mx-auto"
          />
        </div>

        {/* Descripción */}
        <Card>
          <CardContent className="p-4">
            <p className="text-sm leading-relaxed">
              Datacultivo es una aplicación que centraliza datos abiertos del Cabildo de Tenerife 
              y de otras fuentes de datos abiertos, útiles para agricultores: información agroclimática, 
              avisos fitosanitarios, precios de Mercatenerife, y más.
            </p>
          </CardContent>
        </Card>

        {/* Fuente de datos */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Fuentes de datos</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-muted-foreground">
              Los datos provienen de los portales de datos abiertos oficiales:
            </p>
            <ul className="text-sm text-muted-foreground list-disc list-inside space-y-1">
              <li>Cabildo Insular de Tenerife (agroclima, precios, avisos, formación, comercios)</li>
              <li>Gobierno de Canarias – IDECanarias (mapa de cultivos)</li>
            </ul>
            <div className="flex flex-col gap-2">
              <Button 
                variant="outline" 
                className="w-full"
                onClick={() => window.open('https://datos.tenerife.es', '_blank')}
              >
                <ExternalLink size={16} className="mr-2" />
                datos.tenerife.es
              </Button>
              <Button 
                variant="outline" 
                className="w-full"
                onClick={() => window.open('https://www.idecanarias.es', '_blank')}
              >
                <ExternalLink size={16} className="mr-2" />
                idecanarias.es
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Autor */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Autor</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Roberto Rodríguez
            </p>
            <a 
              href="https://www.robertorguez.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-primary hover:underline"
            >
              www.robertorguez.com
            </a>
          </CardContent>
        </Card>

        {/* Licencia y créditos */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Licencia</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              © 2026 – Datacultivo
            </p>
            <p className="text-sm text-muted-foreground mt-1">
              Software libre – Licencia EUPL 1.2
            </p>
          </CardContent>
        </Card>

        {/* Disclaimer */}
        <Card className="bg-amber-50 border-amber-200">
          <CardContent className="p-4">
            <p className="text-sm text-amber-800">
              <strong>Aviso legal:</strong> La información proporcionada en esta aplicación 
              es orientativa. Consulte siempre con técnicos especializados antes de tomar 
              decisiones sobre cultivos o tratamientos fitosanitarios.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default AcercaDePage;
